import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomCellComponent } from '@vendasta/galaxy/table';
import { TaskQueueService } from '../../../crm-components/task-queue/task-queue.service';
import { firstValueFrom, of } from 'rxjs';
import { CrmMultilocationInjectionToken } from '@galaxy/crm/static';

export interface TaskNameData {
  name: string;
  id: string;
  namespace?: string;
}

@Component({
  template: ` <a (click)="openTask()">{{ name }}</a> `,
  imports: [CommonModule],
})
export class TaskNameCellComponent extends CustomCellComponent {
  protected name = '';
  protected taskId = '';
  protected namespace = '';

  private readonly taskQueueService = inject(TaskQueueService);
  private readonly multiLocationConfig = inject(CrmMultilocationInjectionToken);

  set value(newValue: TaskNameData) {
    this.name = newValue.name;
    this.taskId = newValue.id;
    this.namespace = newValue.namespace || '';
  }

  protected async openTask(): Promise<void> {
    const isMultiLocation = await firstValueFrom(this.multiLocationConfig.isMultiLocation$ || of(false));

    if (isMultiLocation && this.namespace) {
      const taskNamespaces = new Map<string, string>();
      taskNamespaces.set(this.taskId, this.namespace);
      this.taskQueueService.setTaskNamespaces(taskNamespaces);
      this.taskQueueService.startQueue([this.taskId]);
    } else if (this.namespace) {
      // For single location, pass the namespace directly
      this.taskQueueService.startQueue([this.taskId], this.namespace);
    } else {
      this.taskQueueService.startQueue([this.taskId]);
    }
  }
}
